import React, { ReactNode } from "react";
import ModalAtom from "../../atoms/Modal";
import styled, { css } from "styled-components";
import { FontSizes } from "../../../theme/fonts";
import Separator from "../../atoms/Separator";
import Button from "../../atoms/Button";

interface ModalProps {
  isOpen: boolean;
  title: string;
  children?: ReactNode;
  onRequestClose: () => void;
}

const Modal = ({ isOpen, title, children, onRequestClose }: ModalProps) => {
  return (
    <ModalAtom isOpen={isOpen} onRequestClose={onRequestClose}>
      <Header>
        <Title>{title}</Title>
        <ButtonStyled
          type="primary-inverted"
          variation="horizontal"
          icon="close"
          onClick={onRequestClose}
        />
      </Header>
      <Separator type="xlarge" />
      {children}
    </ModalAtom>
  );
};

const Title = styled.div`
  display: flex;
  align-items: center;
  font-size: ${FontSizes.Header1};
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ButtonStyled = styled(Button)`
  margin-left: ${4 * 2}px;
`;

export default Modal;
